"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.Error = (props) => {
    var _a;
    return props.error
        ?
            React.createElement("p", { className: props.className },
                React.createElement("b", null, (_a = props.error.name) !== null && _a !== void 0 ? _a : "Error",
                    ":"),
                " ",
                props.error.message)
        : null;
};
const StyledError = styled_components_1.default(exports.Error) `
  background: var(--theme-error-bg);
  color: var(--theme-error-fg);
  border: 1px solid;
  padding: 0.5ex;
`;
exports.default = StyledError;
//# sourceMappingURL=error.js.map